import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export function BannerDialog({
  open, onOpenChange, editingBanner, bannerForm, setBannerForm,
  handleBannerSubmit, saving,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto rounded-3xl">
        <DialogHeader>
          <DialogTitle>{editingBanner ? "Edit Banner" : "Create Banner"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleBannerSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label>Title *</Label>
            <Input value={bannerForm.title} onChange={e => setBannerForm(prev => ({ ...prev, title: e.target.value }))} placeholder="BECE 2026 Prep Sale — 25% Off All Bundles" required className="rounded-xl" data-testid="banner-title-input" />
          </div>
          <div className="space-y-2">
            <Label>Subtitle</Label>
            <Input value={bannerForm.subtitle} onChange={e => setBannerForm(prev => ({ ...prev, subtitle: e.target.value }))} placeholder="Limited time offer! Use code BECE2026" className="rounded-xl" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Button Text</Label>
              <Input value={bannerForm.cta_text} onChange={e => setBannerForm(prev => ({ ...prev, cta_text: e.target.value }))} className="rounded-xl" />
            </div>
            <div className="space-y-2">
              <Label>Button Link</Label>
              <Input value={bannerForm.cta_link} onChange={e => setBannerForm(prev => ({ ...prev, cta_link: e.target.value }))} className="rounded-xl" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Background Color</Label>
              <div className="flex gap-2 items-center">
                <input type="color" value={bannerForm.bg_color} onChange={e => setBannerForm(prev => ({ ...prev, bg_color: e.target.value }))} className="w-10 h-10 rounded-lg border cursor-pointer" />
                <Input value={bannerForm.bg_color} onChange={e => setBannerForm(prev => ({ ...prev, bg_color: e.target.value }))} className="rounded-xl" />
              </div>
            </div>
            <div className="space-y-2">
              <Label>Text Color</Label>
              <div className="flex gap-2 items-center">
                <input type="color" value={bannerForm.text_color} onChange={e => setBannerForm(prev => ({ ...prev, text_color: e.target.value }))} className="w-10 h-10 rounded-lg border cursor-pointer" />
                <Input value={bannerForm.text_color} onChange={e => setBannerForm(prev => ({ ...prev, text_color: e.target.value }))} className="rounded-xl" />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Starts At (optional)</Label>
              <Input type="datetime-local" value={bannerForm.starts_at ? bannerForm.starts_at.slice(0, 16) : ""} onChange={e => setBannerForm(prev => ({ ...prev, starts_at: e.target.value ? new Date(e.target.value).toISOString() : "" }))} className="rounded-xl" />
            </div>
            <div className="space-y-2">
              <Label>Expires At (optional)</Label>
              <Input type="datetime-local" value={bannerForm.expires_at ? bannerForm.expires_at.slice(0, 16) : ""} onChange={e => setBannerForm(prev => ({ ...prev, expires_at: e.target.value ? new Date(e.target.value).toISOString() : "" }))} className="rounded-xl" />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Preview</Label>
            <div className="rounded-xl overflow-hidden p-3 text-center" style={{ backgroundColor: bannerForm.bg_color, color: bannerForm.text_color }}>
              <p className="font-bold">{bannerForm.title || "Banner Title"}</p>
              {bannerForm.subtitle && <p className="text-sm opacity-80">{bannerForm.subtitle}</p>}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <input type="checkbox" checked={bannerForm.is_active} onChange={e => setBannerForm(prev => ({ ...prev, is_active: e.target.checked }))} id="banner-active" />
            <Label htmlFor="banner-active">Active</Label>
          </div>
          <div className="flex gap-3 pt-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="flex-1 rounded-xl">Cancel</Button>
            <Button type="submit" disabled={saving} className="flex-1 rounded-xl bg-primary">
              {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              {editingBanner ? "Update" : "Create"} Banner
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
